import { setErrorDialog, serverUrl, getheader} from "../../../store/api/CommonFunctions";


export function getAgentList(data) {
    if (!data) {
        data = {};
    }
    return dispatch => {
        dispatch({
            type: "GET_AGENT_LIST",
            data: "PENDING"
        });
        fetch(serverUrl + "api/StaffAPI/GetAgentList", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST",
            cache: "no-cache"

        }).then(res => res.json())
            .then(res => {
                if (res.Message === "Error") {
                    res = null;
                }
                dispatch({
                    type: "GET_AGENT_LIST",
                    data: res
                })
            }).catch(err => {
                dispatch({
                    type: "GET_AGENT_LIST",
                    data: null
                });
                console.log("[GET_AGENCT_LIST]", err)
            })
    }
}
export function getMiddlemanList(data) {
    if (!data) {
        data = {};
    }
    return dispatch => {
        dispatch({
            type: "GET_MIDDLEMAN_LIST",
            data: "PENDING"
        });
        fetch(serverUrl + "api/StaffAPI/GetMiddlemanList", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST",
            cache: "default"

        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "لیست معرف")
                    res = null;
                }
                dispatch({
                    type: "GET_MIDDLEMAN_LIST",
                    data: res
                })
            }).catch(err => {
                dispatch({
                    type: "GET_MIDDLEMAN_LIST",
                    data: null
                });
                console.log("[GET_MIDDLEMAN_LIST]", err)
            })
    }
}
export function getRelatedStaffsToAgent(data) {
    if (!data) {
        data = {};
        data.Take = 5;
    }
    return dispatch => {
        dispatch({
            type: "GET_RELATEDSTAFFS",
            data: "PENDING"
        });
        fetch(serverUrl + "api/StaffAPI/GetRelatedStaffsToAgent", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST",
            cache: "no-cache"

        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "دریافت اطلاعات");
                    res = null;
                }
                dispatch({
                    type: "GET_RELATEDSTAFFS",
                    data: res
                })
            }).catch(err => {
                dispatch({
                    type: "GET_RELATEDSTAFFS",
                    data: null
                });
                console.log("[GetRelatedStaffsForAgent]", err)
            })
    }
}